import React from "react";

/** Numbered step title used by the redemption checkout cards. */
export const RedeemStepHeading = ({
  step,
  title,
  subtitle,
}: {
  step: number;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}) => (
  <div className="flex items-start gap-3 min-w-0">
    <span className="inline-flex items-center justify-center text-xs font-semibold rounded-full w-7 h-7 shrink-0 bg-primary-soft text-primary-text tabular-nums">
      {step}
    </span>
    <div className="min-w-0">
      <h2 className="zs-card-title">{title}</h2>
      {subtitle && <p className="mt-0.5 zs-card-subtitle">{subtitle}</p>}
    </div>
  </div>
);
